import ApiService from '@/services/ApiService'
import { reactive } from 'vue'

const store = reactive({
  promo: null
});

export const PROMO_PLACEMENTS = {
  'SCHOOL_TOPIC': 'school_topic',
  'SCHOOL_TOPIC_PAGE': 'school_topic_page',
  'QUIZ_FINISH': 'quiz_finish',
  'TREND_PREDICTOR_FINISH': 'trend_predictor_finish',
}

export const PROMO_PLACEMENT_THRESHOLDS = {
  'school_topic': 3,
  'school_topic_page': 5
}

export function getPromo() {
  return store.promo
}

export function clearPromo() {
  store.promo = null
}

/**
 * @param {string} url
 * @param {Function} callback
 */
export function setPromo({ url, callback }) {
  store.promo = { url, callback }
}

function checkTargetCondition(userValue, targetArray) {
  if (!targetArray || targetArray.length === 0) {
    return true
  } else {
    return userValue && targetArray.includes(userValue)
  }
}

export async function maybeShowPromo(placement, callback = null, count = 0) {
  const threshold = PROMO_PLACEMENT_THRESHOLDS[placement] ?? 0

  if (threshold > count) {
    if (callback) callback({ wasShown: false })
    return
  }

  try {
    const { data: promo } = await ApiService.getPromo(
      { placement },
      { connectionTimout: 3000 }
    )

    // Store only the url and callback
    if (promo?.url) {
      setPromo({
        url: promo.url,
        callback: () => callback({ wasShown: true })
      })
    } else {
      if (callback) callback({ wasShown: false })
    }
  } catch (e) {
    console.warn('Failed to fetch promo', e)
    if (callback) callback({ wasShown: false })
  }
}
